import { createApp } from 'vue'
import App from './App.vue'
import { vuetify } from './plugins'
import router from './router'
import store from './store'
import './assets/styles/main.scss'

const app = createApp(App);

app
  .use(router)
  .use(store)
  .use(vuetify)

store.dispatch('restoreSession').finally(() => {
  app.mount('#app');
});



